import React, { useState, useEffect } from 'react';
import api from './api';

const BrokerMaster = () => {
    const [brokers, setBrokers] = useState([]);
    const [form, setForm] = useState({ name: '', mobile: '', defaultBrokeragePercent: 0.5 });

    const fetchBrokers = async () => {
        const res = await api.get('/brokers');
        setBrokers(res.data);
    };

    useEffect(() => { fetchBrokers(); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/brokers', form);
            alert("Broker Added!");
            setForm({ name: '', mobile: '', defaultBrokeragePercent: 0.5 });
            fetchBrokers();
        } catch (err) { alert("Error adding broker"); }
    };

    return (
        <div className="container mt-4">
            <h4>Broker Master</h4>
            <div className="card p-3 mb-4 bg-light">
                <form onSubmit={handleSubmit} className="row g-2">
                    <div className="col-md-4"><input className="form-control" placeholder="Broker Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required /></div>
                    <div className="col-md-3"><input className="form-control" placeholder="Mobile" value={form.mobile} onChange={e => setForm({...form, mobile: e.target.value})} /></div>
                    <div className="col-md-3"><input type="number" step="0.01" className="form-control" placeholder="Def. Brokerage %" value={form.defaultBrokeragePercent} onChange={e => setForm({...form, defaultBrokeragePercent: e.target.value})} /></div>
                    <div className="col-md-2"><button className="btn btn-primary w-100">Add</button></div>
                </form>
            </div>
            <table className="table table-bordered">
                <thead className="table-dark"><tr><th>Name</th><th>Mobile</th><th>Default %</th></tr></thead>
                <tbody>
                    {brokers.map(b => (
                        <tr key={b._id}>
                            <td>{b.name}</td>
                            <td>{b.mobile}</td>
                            <td>{b.defaultBrokeragePercent}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
export default BrokerMaster;